<template>
  <div style="padding-top: 50px">
    <div class="download-card-bg">
      <div class="download-card">
        <div class="introduce">
          <p class="title">探索知识，收获梦想</p>
          <p class="text">
            欢迎来到魔果云课，一个致力于为全球教师和学生打造充满活力与互动的在线学习社区
          </p>
        </div>
        <button class="download-btn" @click="jumpUrl('Download')">
          下载客户端
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    jumpUrl(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss" scoped>
.download-card-bg {
  background: url("../../../assets/images/home/settle-card-bg.png");
  background-size: 100% 100%;
}
.download-card {
  width: 1200px;
  height: 240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .introduce {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 94px;
    .title {
      font-weight: 500;
      font-size: 34px;
      color: $saas-text-color;
      line-height: 46px;
    }
    .text {
      font-size: 24px;
      color: $saas-text-color;
      line-height: 46px;
    }
  }
  .download-btn {
    width: 180px;
    height: 60px;
    background: linear-gradient(
      132deg,
      $linear-gradient-begin 0%,
      $linear-gradient-end 100%
    );
    border-radius: 86px;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
  }
}
</style>
